/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryCloudAccount extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentQueryCloudAccount");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentQueryCloudAccount.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryCloudAccount>): AwsSsmDocumentQueryCloudAccount {
        let obj = Object.assign(new AwsSsmDocumentQueryCloudAccount(), model);
        AwsSsmDocumentQueryCloudAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryCloudAccount>): AwsSsmDocumentQueryCloudAccount {
        if (!model) return null;
        return AwsSsmDocumentQueryCloudAccount.newInstance(<AwsSsmDocumentQueryCloudAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryCloudAccount) {
        if (!obj) return;

        models.AwsSsmDocumentQueryCloudAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryCloudAccount): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryCloudAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud accounts for the document
     */
    cloud_account_ids: Array<string>;

}
